/**
 * GALATEA SIGNATURE - OVERRIDE REGIONAL: CHILE (es-CL)
 */

export const esCLOverride = {
  entities: {
    document: 'RUT / RUN',
    state: 'Región',
    fiscal: 'Información SII',
  },
};

export default esCLOverride;
